<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">About &amp; Mission</h2>
            </div>

            <div class="page-section-wrap">
                <section class="page-section">
                    <div>
                        <v-row>
                            <v-col cols="12" lg="6">
                                <h2 class="tit">수수료는 낮추고, 작품가치는 올리고</h2>
                            </v-col>
                            <v-col cols="12" lg="6">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">아름다운 작품, 소중한 작품을 소장한다는 것은 참으로 기쁜 일입니다.</h4>
                                </div>
                                <div class="page-text">
                                    <p>작품을 통하여 심리적 안정과 만족감을 느끼고, 가정의 행복과 회사 성장에 기여할 수도 있습니다. 저희는 고객 한 분, 한 분마다 좋은 작품을 소장하면서, 이러한 안정·만족·행복·성장이 함께 하시길 진심으로 바랍니다.</p>
                                    <p>한국인이 운영하는 미술품 경매는 1920년대에 시작되었다고 합니다. 식민지 국가의 영세한 경매소 수준이었던 나라에서, 100년이 지난 지금은, 괄목상대할 정도로 성장한 것이 놀랍습니다. 국가 경제력만큼 고도 성장한 경매시장의 성장 이면(裏面)에는 높은 수수료, 아쉬운 작품 분석력,  도록 및 인건비의 부담, 매뉴얼 및 시스템의 미완성 등 여러 가지 과제도 <br class="d-none d-md-block">남아 있습니다.</p>
                                    <p>캐터옥션은 이러한 과제를 해결하며, 고객 선택의 폭을 넓히기 위하여, 아래와 같이, 고객 서비스를 좀 더 세분화, 차별화하고자 합니다.<br/>이를 통하여, 한국미술시장의 질적인 지속 성장에 일조를 하고자 합니다.</p>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>
                <v-divider class="grey-cb"></v-divider>

                <section class="page-section">
                    <div class="mb-20 mb-md-30">
                        <v-row>
                            <v-col cols="12" lg="6">
                                <h2 class="tit">미션 (Our Mission)</h2>
                            </v-col>
                            <v-col cols="12" lg="6">
                                <h3 class="tit tit--sm line-height-14">폭포는 영어로 Cataract입니다. Cata(Kata)는 ‘밑으로’, <br class="d-none d-md-block">‘낮추다’ 라는 뜻입니다.<br/>KATA 옥션은 ‘미술의 문턱’을 낮추고, ‘고객의 부담’도 <br class="d-none d-md-block">낮추고자 합니다.</h3>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="my-n14 my-md-n20">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 300" src="/images/sub/about/about-mission-img.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs">작품 가치의 발굴</h4>
                                            </div>
                                            <div>
                                                <ul class="letter-list">
                                                    <li><em>-</em><span>그간, 작품에 대한 구체적인 의미나 내용보다는, 다소 애매하고 모호한 작가(作家) 설명으로 대체하곤 했습니다.</span></li>
                                                    <li><em>-</em><span>캐터옥션은 출품하는 작품 그 자체에 집중하여 연구하며, 작품 내면의 다양의 가치 발굴에 노력할 것입니다.</span></li>
                                                    <li><em>-</em><span>즉, 미술사적 연구방법론을 활용하여, 출품작품의 주제, 구도, 형태, 색채, 기법, 재질 등에 관한 형식분석과 양식분석을 실시합니다. 이를 통하여, 해당 작품의 미술사적 의의, 작품 속에서의 위치, 가치 등을 규명합니다.</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 300" src="/images/sub/about/about-mission-img2.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs">&lt;진품성 보장&gt; : 구매시 5종의 서류제공</h4>
                                            </div>
                                            <div>
                                                <ul class="letter-list">
                                                    <li><em>-</em><span>&lt;진품보증서&gt;가 확보된 작품만 출품합니다. 따라서, 작품 구매시, &lt;진품보증서&gt;도 함께 전달됩니다.</span></li>
                                                    <li><em>-</em><span>또한, 캐터옥션 명의의 &lt;상태검사서&gt;, &lt;작품이력서&gt;, &lt;출품확인서&gt;, &lt;작품설명서&gt;등 5가지 서류가 함께 전달됩니다. 이러한 검사분석 과정을 통하여, 신규 구입 작품에 대한 부가가치를 좀더 제고해 드립니다. </span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 300" src="/images/sub/about/about-mission-img3.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs">&lt;시스템 관리&gt; : 인적관리는 지양</h4>
                                            </div>
                                            <div>
                                                <ul class="letter-list">
                                                    <li><em>-</em><span>캐터 옥션은, 고도의 경매업무 매뉴얼, 체계적인 관리시스템, 경매 동향 분석 및 연구자료 등을 통하여, </span></li>
                                                    <li><em>-</em><span>&lt;인적 관리&gt; 보다는 &lt;시스템 관리&gt;를 통하여 신속하고, 다양한 고객만족을 드릴 것입니다.</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 300" src="/images/sub/about/about-mission-img4.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs">&lt;낮은 수수료&gt;</h4>
                                            </div>
                                            <div>
                                                <ul class="letter-list">
                                                    <li><em>-</em><span>캐터옥션은 &lt;경매&gt;와 &lt;프라이빗 세일&gt;을 함께 진행합니다.</span></li>
                                                    <li><em>-</em><span>&lt;경매&gt;와  &lt;프라이빗 세일&gt;의 위탁수수료 및 구매수수료는 5%입니다. </span></li>
                                                    <li><em>-</em><span>고객 여러분의 경제적 부담을 낮춰 드리고, 작품의 가치는 올려 드립니다. </span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>
            </div>
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
export default {
    components: {
        ClientPage,
    },
};
</script>
<style lang="scss" scoped>
</style>